<template>
    <div>

        <div class="hero">
            <p>Online Access <br />for Home Owners</p>
            <img src="https://elitecrafthomes.com/static_files/images/ClientLogin_Header.jpg" alt="">
        </div>

        <div id="client-login">
            <div class="builder-trend">
                <a href="https://buildertrend.net" target="_blank">
                    <img src="https://elitecrafthomes.com/static_files/images/builder_trend.png" alt=""></a>
                <p><a href="https://buildertrend.net" target="_blank">Login</a></p>
            </div>

            <div class="main_content">
                <h2>What is Builder Trend?</h2>
                <p>Building your very own custom home is an exciting experience! There are a lot of important decisions you
                    will need to make from the time you approve the initial drawings, to moving into your new home! We know
                    how important every decison you make is, and how important it is that you can follow every aspect of the
                    building process.</p>
                <p>That’s why we offer secure, online access to your own webpage with all the details of your new home! You
                    will be able to track photos of the construction progress, view the build schedule, view and approve
                    change orders and selections, as well as access important documents. From online warranty claims, to the
                    online messaging system, you can easily communicate with our team, 24/7, no matter if you are at home,
                    work, or even on vaction!</p>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                hero: 'Online Access for Home Owners'
            }
        }
    }
</script>

<style lang="scss" scoped>

    @font-face {
        font-family: "Tahu";
        src: url("https://elitecrafthomes.com/static_files/fonts/Tahu.ttf"),
        url("https://elitecrafthomes.com/static_files/fonts/Tahu.otf") format('opentype');
    }

    @font-face {
        font-family: "LibreBaskerville Bold";
        src: url("https://elitecrafthomes.com/static_files/fonts/LibreBaskerville-Bold.ttf")
    }

    * {
        box-sizing: border-box;
    }

    h2 {
        margin-top: 100px;
    }

    .main_content {
        h2 {
            padding-bottom: 20px;
            font-family: 'LibreBaskerville Bold', 'Muli', 'Avenir Next', 'Helvetica Neue', serif;
        }
        p {
            padding: 0 0 5px 0;
            font-size: 17px;
            line-height: 1.7;
        }
    }

    form {
        margin: 100px 0;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    input {
        padding: 15px;
        width: 100%;
        display: block;
        font-size: 24px;
        border: none;
        border-bottom: 3px solid silver;
    }

    br {
        display: none;
    }

    input:not(:first-child) {
        margin: 30px 0;
    }

    input:focus, button:focus {
        outline: none;
    }

    #client-login {
        margin: 100px auto;
        width: 60%;
        .builder-trend {
            display: table;
            margin: 0 auto;
            img {
                display: table-cell;
                max-width: 30vw;
                width: 100%;
                vertical-align: middle;
            }
            p {
                display: table-cell;
                vertical-align: middle;
                padding-left: 15px;
                a {
                    font-size: 22px;
                    border: 3px solid white;
                    background-color: #425152;
                    color: white;
                    width: auto;
                    padding: 4px 30px;
                    text-decoration: none;
                    text-align: center;
                    -webkit-box-shadow: -1px 2px 3px 1px rgba(0,0,0,0.71);
                    -moz-box-shadow: -1px 2px 3px 1px rgba(0,0,0,0.71);
                    box-shadow: -1px 2px 3px 1px rgba(0,0,0,0.71);
                }
            }

        }

    }

    #video-demo {
        margin: 50px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'LibreBaskerville Bold', 'Muli', 'Avenir Next', 'Helvetica Neue', serif;
        p {
            font-size: 22px;
            padding-right: 25px;
        }
    }

    .hero {
        position: relative;
        max-width: 100vw;
        width: 100%;
        height: 530px;
        max-height: 530px;
        background-color: rgba(0, 0, 0, 0.65);
        color: white;
        padding-bottom: 50px;

        overflow: hidden;
        p {
            position: absolute;
            font-size: 72px;
            line-height: 1.4;
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%);
            -moz-transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
            -o-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            font-family: "Tahu", cursive;
            padding-left: 25px;
            z-index: 899;
            color: white;
        }
        img {
            position: absolute;
            top: 0;
            left: 0;
            height: 530px;
            max-height: 530px;
            width: 100%;
            max-width: 100vw;
            object-fit: fill;
            opacity: .5;
        }
    }

    .video {
        width: 300px;
        height: 300px;
        background-color: silver;
        float: right;
        text-align: right;
    }

    /* iPads (portrait) ----------- */
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        h2 {
            font-size: 32px;
        }

        h3 {
            text-align: right;
        }

        .video {
            width: 318px;
            height: 281px;
        }
        .hero {
            overflow: hidden;
            max-height: 500px;
            height: 500px;
            br {
                display: block;
            }
            p {
                padding-left: 100px;
                font-size: 4em;
                left: 0;
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                -ms-transform: translateY(-50%);
                -o-transform: translateY(-50%);
                transform: translateY(-50%);
            }
            img {
                max-height: 500px;
                height: 500px;
            }
        }

        .main_content {
            width: 70vw;
            margin: 0 auto;
            text-align: center;
            h2 {
                text-align: left;
                padding-bottom: 10px;
            }
            p {
                text-align: left;
                padding: 0 0 5px 0;
            }
        }
    }

    /* Smartphones (portrait) */
    @media only screen and (max-width: 450px) {
        h2 {
            font-size: 20px;
        }

        p {
            padding: 0;
            font-size: 16px;
        }



        #video-demo {
            width: 100%;
            display: block;
            text-align: center;
            margin: 50px auto;
            position: relative;
            height: 250px;
            font-family: 'LibreBaskerville Bold', 'Muli', 'Avenir Next', 'Helvetica Neue', serif;
            .video {
                position: absolute;
                bottom: 0;
                left: 50%;
                -webkit-transform: translateX(-50%);
                -moz-transform: translateX(-50%);
                -ms-transform: translateX(-50%);
                -o-transform: translateX(-50%);
                transform: translateX(-50%);
                margin: 0 auto;
                text-align: center;
                width: 234px;
                height: 202px;
            }
        }


        .hero {
            overflow: hidden;
            max-height: 450px;
            height: 450px;
            p {
                font-size: 3em;
                left: 0;
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                -ms-transform: translateY(-50%);
                -o-transform: translateY(-50%);
                transform: translateY(-50%);
            }
            br {
                display: block;
            }
            img {
                -webkit-transform: scaleX(1.4);
                -moz-transform: scaleX(1.4);
                -ms-transform: scaleX(1.4);
                -o-transform: scaleX(1.4);
                transform: scaleX(1.4);
                max-height: 450px;
                height: 100%;
            }
        }

        .main_content {
            text-align: center;
            margin: 0 auto;
            width: 70%;
            padding: 0;
            h2 {
                font-size: 18px;
                text-align: center;
            }
            p {
                font-size: 18px;
                text-align: justify;
            }
        }

        #client-login {
            margin: 40px auto;
            width: 100%;
            .builder-trend {
                margin: 0 auto;
                display: block;
                text-align: center;
                img {
                    max-width: 70vw;
                    width: 100%;
                    display: block;
                    margin: 0 auto;
                }
                p {
                    padding: 10px 0 0 0;
                    margin-bottom: 0;
                    display: block;
                    a {
                        font-size: 16px;
                        width: auto;
                        padding: 4px 30px;
                    }
                }

            }

        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Client.vue